// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3Fn-i","col":"styles_col__2ERuh","fulfillmentStatus":"styles_fulfillmentStatus__1I-9V","emailCol":"styles_emailCol__BKyzh"};